import { Formik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { Loadable, ToastMessage } from '../../../../common';
import {
    Portlet, PortletBody,
    PortletHeader, PortletHeaderToolbar
} from "../../../../partials/content/Portlet";

import {
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    Switch,
    TextField,
    Tooltip,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    MenuItem
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import DeleteIcon from '@mui/icons-material/Delete';
import { BackButton } from "../../../../common/BackButton";
import { ConfigurationClearConfirmationDialog } from "../ClientsConfigurationClearConfirmationDialog";
import { AddClientsDialog } from "../ClientsDialog";
import { errorToastify } from "../../../../util/toast";
import { FHIRProviderType } from "../../../../store/constants/pages";
import { toast } from "react-toastify";
import { useData } from "@pure-ptr/react";
import { generateStats, getEdiBasedPricing } from "../../../../store/api/pricers";

const useStyles = makeStyles(theme => ({
    deleteButton: {
        color: '#d9534f',
        marginLeft: '20px',
    },
    button: {
        margin: theme.spacing(1),
    },

    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '80%',
    },
    textArea: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '80%',
    },
    switch: {
        margin: theme.spacing(1),
    },
    switchAccount: {
        margin: 0,
    },
    switchAccountFormLabel: {

        position: 'absolute',
        bottom: 0
    },
    margin: {
        margin: theme.spacing(1),
    },

    formControl: {
        margin: theme.spacing(1),
        width: '80%',
    },
    updatedSection: {
        display: 'block'
    },
    approveIcon: {
        position: 'absolute',
        bottom: '10px'
    },
    updatedSectionContainer: {
        marginLeft: '8px'
    },
    loadable:{
        background:"white"
    },
    boxPadding:{
        padding:"0 40px 0 40px" 
    }

}));

const headerBgColor = {background:"#f7f8fa"}

export default function ClientConfigurationPage({
    intl, initialValues, initialValuesAccount, initialValuesFHIR, clientId, configuration, isEdit, client, updateAccountPending, updateFHIRPending,
    isAccountEdit, isFHIREdit, history,
    getClientPending, getClientAccountPending, getClientFHIRPending, createClientPending, createClientAccountPending, createClientFHIRPending,testFHIRConnectionPending, updateClientPending, deleteClientPending, isSuperAdmin,
    actions: {
        getAccountConfiguration,
        getFHIRConfiguration,
        getConfiguration,
        createConfiguration,
        createAccountConfiguration,
        createFHIRConfiguration,
        testFHIRConnection,
        updateConfiguration,
        updateAccountConfiguration,
        updateFHIRConfiguration,
        deleteConfiguration,
        resetClientConfiguration,
        resetClientAccountConfiguration,
        resetClientFHIRConfiguration,
        getClient,

    } }) {

    const classes = useStyles();

    const [open, setOpen] = useState(false)
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
    const saveSectionRef = useRef("");
    const [ediBasedPricing, setEdiBasedPricing] = useState(false);
    const [canSubmitEdiBasedPricing, setCanSubmitEdiBasedPricing] = useState(false);
    const [submitGenerateStats, setSubmitGenerateStats] = useState(false);

    useEffect(() => {
        getConfiguration(clientId, isSuperAdmin);
        getAccountConfiguration(clientId);
        getFHIRConfiguration(clientId);
        return () => {
            resetClientConfiguration();
            resetClientAccountConfiguration();
            resetClientFHIRConfiguration();
        }
    }, [clientId, getConfiguration, resetClientConfiguration, getAccountConfiguration, getFHIRConfiguration]);

    useEffect(() => {
        getClient(clientId);
    }, [getClient, clientId]);

    const {
        error: ediError
    } = useData(async () => {
        if (!clientId) return;
        setEdiBasedPricing(false);
        setCanSubmitEdiBasedPricing(false);
        const ediResponse = await getEdiBasedPricing(clientId);
        setEdiBasedPricing(ediResponse.isFeatureEnabled);
        setCanSubmitEdiBasedPricing(ediResponse.canSubmit);
    }, [clientId]);

    const {
        error: generateStatsError,
        isPending: generateStatsPending,
        reload: generateRates
    } = useData(async () => {
        if (!submitGenerateStats) return;
        setSubmitGenerateStats(false);
        await generateStats(clientId);
        setCanSubmitEdiBasedPricing(false);
    }, [clientId]);

    const handleCallback = () => {
        getConfiguration(clientId, isSuperAdmin)
        history.push('/admin/clients?persist=true');
    }

    const handleSubmitGenerateStats = () => {
        setSubmitGenerateStats(true);
        generateRates();
    }

    const handleTestCallback = () => {
        toast.success(
            "Connection Successful.",
            {
                autoClose: 3000,
                pauseOnHover: true,
                closeOnClick: true,
            }
        );
    }

    const handleTestConnetion = (config) =>{
        const payload ={
            ProviderClientId:config.providerClientId,
            ProviderClientSecret:config.providerClientSecret
        }
        testFHIRConnection(payload,handleTestCallback);
    }

    const disabled = (data,dirty) =>{
        return !data.providerClientId || !data.providerClientSecret || !dirty;
    }


    const handleDialogOpen = () => { setOpen(true) }
    const handleDialogClose = () => { setOpen(false) }
    const handleConfirmationDialogOpen = () => { setOpenConfirmationDialog(true) }
    const handleConfirmationDialogClose = () => { setOpenConfirmationDialog(false) }

    const handleDeleteConfiguration = () => {
        handleConfirmationDialogClose()
        deleteConfiguration(clientId, handleCallback)
    }

    return (<>
        <Loadable loading={getClientPending || createClientPending || updateClientPending || deleteClientPending} parentClassName={classes.loadable}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={values => {
                    const errors = {};

                    if (values.eapgEnabled) {
                        if (!values.siteName) {
                            errors["siteName"] = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (!/^[a-zA-Z0-9 ]+$/.test(values.siteName)) {
                            errors["siteName"] = "Only letters, digits, and spaces allowed";
                        } else if (values.siteName.length < 5) {
                            errors["siteName"] = "Minimum 5 characters";
                        } else if (values.siteName.length > 100) {
                            errors["siteName"] = "Maximum 100 characters";
                        }
                    }


                    return errors;
                }}
                onSubmit={(values, { }) => {
                    const saveSection = saveSectionRef.current;
                    let payload = {
                        ...initialValues,
                        clientId: clientId,
                    };

                    if (saveSection === 'product') {
                        payload = {
                            ...payload,
                            customClaimStatusEnabled: values.customClaimStatusEnabled,
                            customRCMTeamAssignmentEnabled: values.customRCMTeamAssignmentEnabled,
                            summaryDashboardEnabled: values.summaryDashboardEnabled,
                            usePlanIdMapping: values.usePlanIdMapping,
                            eapgEnabled: values.eapgEnabled,
                            siteName: values.eapgEnabled ? values.siteName?.trim() : initialValues.siteName,
                        };
                    } else if (saveSection === 'edi') {
                        payload = {
                            ...payload,
                            prefixExcluded: values.prefixExcluded,
                            postfixExcluded: values.postfixExcluded,
                            fileExtensionsExcluded: values.fileExtensionsExcluded,
                            notifyOnFileNotReceived: values.notifyOnFileNotReceived,
                            notifyAfterDaysFileNotReceived: values.notifyAfterDaysFileNotReceived,
                        };
                    } else if (saveSection === 'ai') {
                        payload = {
                            ...payload,
                            claimAnalysisChatbotEnabled: values.claimAnalysisChatbotEnabled,
                            contractDocumentChatbotEnabled: values.contractDocumentChatbotEnabled,
                            supplementaryKnowledgeBaseEnabled: values.supplementaryKnowledgeableEnabled,
                            supplementaryPromptEnabled: values.supplementaryPromptEnabled,
                            claimSemanticSearchEnabled: values.claimSemanticSearchEnabled,
                            claimAnalysisFollowupEnabled: values.claimAnalysisChatbotEnabled ? values.claimAnalysisFollowupEnabled : false,
                            contractFollowupEnabled: values.contractDocumentChatbotEnabled ? values.contractFollowupEnabled : false,
                            aiEnabled: values.claimAnalysisChatbotEnabled || values.contractDocumentChatbotEnabled || values.supplementaryKnowledgeableEnabled || values.supplementaryPromptEnabled || values.claimSemanticSearchEnabled,
                        };
                    } else {
                        // Fallback to original behavior if no section is specified (should not happen with separate buttons)
                        payload = {
                            ...payload,
                            prefixExcluded: values.prefixExcluded,
                            postfixExcluded: values.postfixExcluded,
                            fileExtensionsExcluded: values.fileExtensionsExcluded,
                            notifyOnFileNotReceived: values.notifyOnFileNotReceived,
                            notifyAfterDaysFileNotReceived: values.notifyAfterDaysFileNotReceived,
                            customClaimStatusEnabled: values.customClaimStatusEnabled,
                            summaryDashboardEnabled: values.summaryDashboardEnabled,
                            usePlanIdMapping: values.usePlanIdMapping,
                            eapgEnabled: values.eapgEnabled,
                            aiEnabled: values.claimAnalysisChatbotEnabled || values.contractDocumentChatbotEnabled || values.supplementaryKnowledgeableEnabled || values.supplementaryPromptEnabled || values.claimSemanticSearchEnabled,
                            claimAnalysisChatbotEnabled: values.claimAnalysisChatbotEnabled,
                            contractDocumentChatbotEnabled: values.contractDocumentChatbotEnabled,
                            supplementaryKnowledgeBaseEnabled: values.supplementaryKnowledgeableEnabled,
                            supplementaryPromptEnabled: values.supplementaryPromptEnabled,
                            claimAnalysisFollowupEnabled: values.claimAnalysisChatbotEnabled ? values.claimAnalysisFollowupEnabled : false,
                            contractFollowupEnabled: values.contractDocumentChatbotEnabled ? values.contractFollowupEnabled : false,
                            claimSemanticSearchEnabled: values.claimSemanticSearchEnabled,
                            customRCMTeamAssignmentEnabled: values?.customRCMTeamAssignmentEnabled,
                            ...(values?.eapgEnabled ? { siteName: values?.siteName?.trim() } : {})
                        };
                    }

                    if (isEdit) {
                        updateConfiguration(payload, handleCallback)
                    } else {
                        createConfiguration(payload, handleCallback)
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    dirty
                }) => {
                    const productFields = ['customClaimStatusEnabled', 'customRCMTeamAssignmentEnabled', 'summaryDashboardEnabled', 'eapgEnabled', 'siteName', 'usePlanIdMapping'];
                    const ediFields = ['prefixExcluded', 'postfixExcluded', 'fileExtensionsExcluded', 'notifyAfterDaysFileNotReceived', 'notifyOnFileNotReceived'];
                    const aiFields = ['claimAnalysisChatbotEnabled', 'contractDocumentChatbotEnabled', 'supplementaryKnowledgeableEnabled', 'claimSemanticSearchEnabled', 'supplementaryPromptEnabled'];

                    const isProductDirty = productFields.some(f => (values[f] ?? "") !== (initialValues[f] ?? ""));
                    const isEDIDirty = ediFields.some(f => (values[f] ?? "") !== (initialValues[f] ?? ""));
                    const isAIDirty = aiFields.some(f => (values[f] ?? "") !== (initialValues[f] ?? ""));

                    return (
                        <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
                            <Box sx={{ width: '100%' }}>
                                <Portlet>
                                    <PortletHeader
                                        style={{...headerBgColor}}
                                        toolbar={
                                            <PortletHeaderToolbar className='w-100'>
                                                <Grid container alignItems="center">
                                                    <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                        <Typography className="text-dark" variant="h6">{`Configuration - ${client?.name}`}</Typography>
                                                            <Tooltip title="Clear Configuration of this client">
                                                                <Button
                                                                    size="small"
                                                                    onClick={handleConfirmationDialogOpen}
                                                                    className={classes.deleteButton}
                                                                    startIcon={<DeleteIcon />}>
                                                                    Clear
                                                                </Button>
                                                            </Tooltip>
                                                    </Grid>
                                                    <Grid md={6} container className="justify-content-end" >
                                                        <BackButton text={dirty ? "Cancel" : "Back"} defaultRoute="/admin/clients?persist=true" />
                                                       
                                                    </Grid>
                                                </Grid>
                                            </PortletHeaderToolbar>
                                        }
                                    />
                                </Portlet>
                            </Box>


                            {/* EDI Configurations Section */}
                            <Box sx={{ width: '100%' }} >
                                <Portlet>
                                    <PortletHeader
                                        style={{...headerBgColor}}
                                        toolbar={
                                            <PortletHeaderToolbar className='w-100'>
                                                <Grid container alignItems="center">
                                                    <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                        <Typography className="text-dark" variant="h6">EDI Configurations</Typography>
                                                    </Grid>
                                                    <Grid md={6} container className="justify-content-end">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            type="submit"
                                                            onClick={() => { saveSectionRef.current = 'edi'; }}
                                                            disabled={createClientPending || updateClientPending || ( !isEDIDirty)}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </PortletHeaderToolbar>
                                        }
                                    />
                                    <PortletBody>
                                    <Grid container spacing={2}>
                                        <Grid item md={6}>
                                            <TextField
                                                multiline
                                                minRows='1'
                                                maxRows='8'
                                                label="Prefix Excluded"
                                                name="prefixExcluded"
                                                className={classes.textArea}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.prefixExcluded}
                                                helperText='e.g. SLICED_;HEALTH_'
                                                error={Boolean(touched.prefixExcluded && errors.prefixExcluded)}
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <TextField
                                                multiline
                                                minRows='1'
                                                maxRows='8'
                                                label="Postfix Excluded"
                                                name="postfixExcluded"
                                                className={classes.textArea}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.postfixExcluded}
                                                helperText='e.g. _SLICED;_HEALTH'
                                                error={Boolean(touched.postfixExcluded && errors.postfixExcluded)}
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <TextField
                                                multiline
                                                minRows='1'
                                                maxRows='8'
                                                label="File Extensions Excluded"
                                                name="fileExtensionsExcluded"
                                                className={classes.textArea}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.fileExtensionsExcluded}
                                                helperText='e.g. exe;pdf;word'
                                                error={Boolean(touched.fileExtensionsExcluded && errors.fileExtensionsExcluded)}
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <TextField
                                                label="Notify After Days File Not Received"
                                                name="notifyAfterDaysFileNotReceived"
                                                type="number"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.notifyAfterDaysFileNotReceived}
                                                helperText={touched.notifyAfterDaysFileNotReceived && errors.notifyAfterDaysFileNotReceived}
                                                error={Boolean(touched.notifyAfterDaysFileNotReceived && errors.notifyAfterDaysFileNotReceived)}
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="notifyOnFileNotReceived"
                                                        checked={values.notifyOnFileNotReceived}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"
                                                    />
                                                }
                                                label="Notify On File Not Received"
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <Grid container alignItems="center" spacing={2}>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={
                                                        <Switch
                                                            name="ediBasedPricing"
                                                            checked={ediBasedPricing || false}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            color="primary"
                                                            disabled={true}
                                                        />
                                                        }
                                                        label="EDI-Based Pricing"
                                                    />
                                                </Grid>

                                                <Grid item>
                                                    <Button
                                                        type="button"
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSubmitGenerateStats}
                                                        disabled={canSubmitEdiBasedPricing === false || generateStatsPending !== null}
                                                    >
                                                        {generateStatsPending !== null ? "Generating..." : "Generate Stats"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </PortletBody>
                            </Portlet>
                            </Box>


                            {/* Product Configurations Section */}
                            <Box sx={{ width: '100%'}} className={classes.boxPadding} >
                                <Portlet>
                                    <PortletHeader
                                        style={{...headerBgColor}}
                                        toolbar={
                                            <PortletHeaderToolbar className='w-100'>
                                                <Grid container alignItems="center">
                                                    <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                        <Typography className="text-dark" variant="h6">Product Configurations</Typography>
                                                    </Grid>
                                                    <Grid md={6} container className="justify-content-end">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            type="submit"
                                                            onClick={() => { saveSectionRef.current = 'product'; }}
                                                            disabled={createClientPending || updateClientPending || ( !isProductDirty)}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </PortletHeaderToolbar>
                                        }
                                    />
                                    <PortletBody>
                                    <Grid container spacing={2}>
                                        <Grid item md={4}>
                                            <FormControlLabel
                                                sx={{ display: "block" }}
                                                control={
                                                    <Switch
                                                        name="customClaimStatusEnabled"
                                                        checked={values.customClaimStatusEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"
                                                    />
                                                }
                                                label="Enable Custom Claim Statuses"
                                            />
                                        </Grid>
                                        {isSuperAdmin && (
                                            <Grid item md={4}>
                                                <FormControlLabel
                                                    sx={{ display: "block" }}
                                                    control={
                                                        <Switch
                                                            name="customRCMTeamAssignmentEnabled"
                                                            checked={values.customRCMTeamAssignmentEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Enable RCM Teams"
                                                />
                                            </Grid>
                                        )}
                                        <Grid item md={4}>
                                            <FormControlLabel
                                                sx={{ display: "block" }}
                                                control={
                                                    <Switch
                                                        name="summaryDashboardEnabled"
                                                        checked={values.summaryDashboardEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"
                                                    />
                                                }
                                                label="Show Summary Dashboard"
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="usePlanIdMapping"
                                                        checked={values.usePlanIdMapping}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"
                                                    />
                                                }
                                                label='Process Claims Using Payer Mapping'
                                            />
                                        </Grid>
                                        {isSuperAdmin && (
                                            <Grid item md={4}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: "30px" }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                name="eapgEnabled"
                                                                checked={values.eapgEnabled}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Enable EAPG"
                                                    />
                                                    {values.eapgEnabled && (
                                                        <TextField
                                                            label="Site Name"
                                                            required
                                                            name="siteName"
                                                            sx={{ "&.MuiFormControl-root": { width: "300px", margin: 0 } }}
                                                            margin="normal"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            value={values.siteName}
                                                            helperText={touched.siteName && errors.siteName}
                                                            error={Boolean(touched.siteName && errors.siteName)}
                                                        />
                                                    )}
                                                </Box>
                                            </Grid>
                                        )}
                                    </Grid>
                                </PortletBody>
                            </Portlet>
                            </Box>


                            {/* AI Capabilities Section */}
                            <Box sx={{ width: '100%' }} className={classes.boxPadding}>
                                <Portlet>
                                    <PortletHeader
                                        style={{...headerBgColor}}
                                        toolbar={
                                            <PortletHeaderToolbar className='w-100'>
                                                <Grid container alignItems="center">
                                                    <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                        <Typography className="text-dark" variant="h6">AI Capabilities</Typography>
                                                    </Grid>
                                                    <Grid md={6} container className="justify-content-end">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            type="submit"
                                                            onClick={() => { saveSectionRef.current = 'ai'; }}
                                                            disabled={createClientPending || updateClientPending || ( !isAIDirty)}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </PortletHeaderToolbar>
                                        }
                                    />
                                    <PortletBody>
                                    {isSuperAdmin && (
                                        <Grid container spacing={2}>
                                            <Grid item md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            name="claimAnalysisChatbotEnabled"
                                                            color="primary"
                                                            checked={values.claimAnalysisChatbotEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    }
                                                    label="Claim Analysis Chatbot"
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            name="contractDocumentChatbotEnabled"
                                                            color="primary"
                                                            checked={values.contractDocumentChatbotEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    }
                                                    label="Contract Document Chatbot"
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            name="supplementaryKnowledgeableEnabled"
                                                            color="primary"
                                                            checked={values.supplementaryKnowledgeableEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    }
                                                    label="IQ Knowledge Base"
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            name="claimSemanticSearchEnabled"
                                                            color="primary"
                                                            checked={values.claimSemanticSearchEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    }
                                                    label="Claim Semantic Search"
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            name="supplementaryPromptEnabled"
                                                            color="primary"
                                                            checked={values.supplementaryPromptEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                    }
                                                    label="Supplementary Prompts"
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                </PortletBody>
                            </Portlet>
                            </Box>
                        </form>
                    );
                }}
            </Formik>
        </Loadable>
        {/* Account Section  */}
        <Loadable loading={updateAccountPending || createClientAccountPending || getClientAccountPending}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValuesAccount}
                validate={values => {

                    const errors: any = {};

                    if (!values.accountIdentifierNumbers) {
                        errors.accountIdentifierNumbers = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                    return errors;
                }}
                onSubmit={(values, { }) => {

                    let payload = {
                        accountIdentifierNumbers: values?.accountIdentifierNumbers,
                        mergeClaims: values?.mergeClaims,
                        clientId: clientId,
                    }

                    if (isAccountEdit) {
                        updateAccountConfiguration(payload, handleCallback)
                    }
                    else {
                        createAccountConfiguration(payload, handleCallback)
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    dirty
                }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
                        <Portlet>
                            <PortletHeader
                                style={{...headerBgColor}}
                                toolbar={
                                    <PortletHeaderToolbar className='w-100'>
                                        <Grid container alignItems="center">
                                            <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                <Typography className="text-dark" variant="h6">Account</Typography>


                                            </Grid>
                                            <Grid md={6} container className="justify-content-end">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className='ml-3'
                                                    type="submit"
                                                    disabled={!dirty}
                                                >
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </PortletHeaderToolbar>
                                }
                            />
                            <PortletBody>
                                <div className={classes.container}>
                                    <div className="row" style={{ width: '90%' }}>



                                        <div className="col-md-6">
                                            <TextField
                                                type="number"
                                                required
                                                label="Account digit"
                                                name="accountIdentifierNumbers"
                                                className={classes.textField}

                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.accountIdentifierNumbers}
                                                helperText={
                                                    touched.accountIdentifierNumbers && errors.accountIdentifierNumbers
                                                }
                                                error={Boolean(
                                                    touched.accountIdentifierNumbers && errors.accountIdentifierNumbers
                                                )}
                                            />


                                            {initialValuesAccount?.updatedAt &&
                                                <Tooltip title="Validate Claims">
                                                    <IconButton size='small' onClick={handleDialogOpen} className={classes.approveIcon}>
                                                        <CheckCircleOutlineIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            }



                                        </div>

                                        <div className="col-md-6">
                                            <FormControlLabel
                                                className={classes.switchAccountFormLabel}
                                                control={
                                                    <Switch
                                                        name="mergeClaims"
                                                        checked={values.mergeClaims}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"
                                                    />
                                                }
                                                label="Merge claims by account id."
                                            />
                                        </div>



                                    </div>

                                </div>
                                {initialValuesAccount?.updatedAt &&
                                    <div className={classes.updatedSectionContainer}>
                                        <span className={classes.updatedSection}>
                                            <b>Updated At :</b> {initialValuesAccount?.updatedAt}
                                        </span>

                                        <span className={classes.updatedSection}>
                                            <b>Updated by :</b> &nbsp;{initialValuesAccount?.updatedBy}
                                        </span>
                                    </div>
                                }

                            </PortletBody>
                        </Portlet>
                    </form>
                )}
            </Formik>
        </Loadable>

        {/* FHIR Section  */}
        <Loadable loading={updateFHIRPending || createClientFHIRPending || getClientFHIRPending || testFHIRConnectionPending}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValuesFHIR}
                validate={values => {
                    const errors: any = {};

                     if (values.providerType != 0 && values.providerType != 1) {
                         errors.providerType = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                     if (!values.practiceId) {
                         errors.practiceId = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                     if (!values.providerClientSecret) {
                         errors.providerClientSecret = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                     if (!values.providerClientId) {
                         errors.providerClientId = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                    return errors;
                }}
                onSubmit={(values, { }) => {
                    let payload = {
                        providerType: values?.providerType,
                        practiceId: values?.practiceId,
                        providerClientSecret: values?.providerClientSecret,
                        providerClientId: values?.providerClientId,
                        isPatientDetailsEnabled: values?.isPatientDetailsEnabled,
                        isClaimNotedEnabled: values?.isClaimNotedEnabled,
                        clientId
                    }

                    if (isFHIREdit) {
                        updateFHIRConfiguration(payload, handleCallback)
                    }
                    else {
                        createFHIRConfiguration(payload, handleCallback)
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    dirty
                }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
                        <Portlet>
                            <PortletHeader
                                style={{...headerBgColor}}
                                toolbar={
                                    <PortletHeaderToolbar className='w-100'>
                                        <Grid container alignItems="center">
                                            <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                <Typography className="text-dark" variant="h6">FHIR</Typography>


                                            </Grid>
                                            <Grid md={6} container className="justify-content-end">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className='ml-3'
                                                    onClick={()=> handleTestConnetion(values)}                            
                                                    disabled={disabled(values,dirty)}
                                                >
                                                    Test Credentials
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className='ml-3'
                                                    type="submit"
                                                    disabled={!dirty}
                                                >
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </PortletHeaderToolbar>
                                }
                            />
                            <PortletBody>
                                <div className={classes.container}>
                                    <div className="row" style={{ width: '90%' }}>
                                        <div className="col-md-6">
                                            <FormControl className={classes.formControl}>
                                                <InputLabel htmlFor="providerType">EHR</InputLabel>
                                                <Select
                                                    required={true}
                                                    name="providerType"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.providerType}
                                                    error={Boolean(touched.providerType && errors.providerType)}
                                                >
                                                    {FHIRProviderType.map((item, index) => (
                                                        <MenuItem
                                                            key={`${item.id}`}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>{touched.providerType && errors.providerType}</FormHelperText>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                label="Client ID"
                                                required
                                                name="providerClientId"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.providerClientId}
                                                helperText='e.g. AthenaHealth API ClientId'
                                                error={Boolean(touched.providerClientId && errors.providerClientId)}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <TextField
                                                label="Client Secret"
                                                required
                                                name="providerClientSecret"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.providerClientSecret}
                                                helperText='e.g. AthenaHealth API ClientSecret'
                                                error={Boolean(touched.providerClientSecret && errors.providerClientSecret)}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <TextField
                                                label="PracticeId"
                                                required
                                                name="practiceId"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.practiceId}
                                                helperText='e.g. Facility Practice Id'
                                                error={Boolean(touched.practiceId && errors.practiceId)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <FormControlLabel
                                                sx={{ paddingTop: 3 }}
                                                control={
                                                    <Switch
                                                        name="isPatientDetailsEnabled"
                                                        checked={values.isPatientDetailsEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"                                                    
                                                    />
                                                }
                                                label="Patient Details"
                                            />
                                            
                                        </div>
                                        <div className="col-md-6">
                                            <FormControlLabel
                                                sx={{ paddingTop: 3 }}
                                                control={
                                                    <Switch
                                                        name="isClaimNotedEnabled"
                                                        checked={values.isClaimNotedEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        color="primary"                                                
                                                    />
                                                }
                                                label="Claim Notes"
                                            />
                                            
                                        </div>
                                    </div>

                                </div>
                            </PortletBody>
                        </Portlet>
                    </form>
                )}
            </Formik>
        </Loadable>
        <AddClientsDialog open={open} handleClose={handleDialogClose} accountDigit={parseInt(initialValuesAccount?.accountIdentifierNumbers)} clientId={clientId} />
        <ConfigurationClearConfirmationDialog open={openConfirmationDialog} handleClose={handleConfirmationDialogClose} handleSubmit={handleDeleteConfiguration} />
    </>);

}

